import { EnvironmentProviders } from '@angular/core';
import { provideEffects } from '@ngrx/effects';
import { provideState } from '@ngrx/store';
import * as DelegationsStore from 'src/app/delegations/store';

export const provideDelegationsStore = (): EnvironmentProviders[] => [
    provideState(DelegationsStore.delegationsFeatureKey, DelegationsStore.delegationsReducer),
    provideEffects([DelegationsStore.DelegationsEffects])
];
